// import ReactInput from "../../../components/Inputs/ReactInput";
// import InputLabel from "../../../components/Inputs/InputLable";
import { isObject, useFormikContext } from "formik";
// import ReactSelect from "../../../components";
// import ReactMultiSelect from "../../../components/Inputs/ReactMultiSelect";
import { useContext } from "react";
import { UserContext } from "../../../Context/UserContextAPI";
import ReactSelect from "../../../components/ReactSelect/ReactSelect";
import ReactMultiSelect from "../../../components/ReactSelect/ReactMultiSelect";
import ReactInput from "../../../components/InputList/ReactInput/ReactInput";
import InputLabel from "../../../components/ReactSelect/InputLabel";

const SettingsForm = () => {
  const { values, setFieldValue } = useFormikContext();
  const { accessPerm } = useContext(UserContext);
  const daysOfWeekData = [
    { id: "0", value: "Sunday", label: "Sunday" },
    { id: "1", value: "Monday", label: "Monday" },
    { id: "2", value: "Tuesday", label: "Tuesday" },
    { id: "3", value: "Wednesday", label: "Wednesday" },
    { id: "4", value: "Thursday", label: "Thursday" },
    { id: "5", value: "Friday", label: "Friday" },
    { id: "6", value: "Saturday", label: "Saturday" },
  ];

  return (
    <div className="border p-4 rounded">
      <div className="card-title d-flex align-items-center">
        <h5 className="mb-0">System Settings</h5>
      </div>
      <hr />
      <div className="row mb-3">
        <InputLabel
          className="col-sm-3 col-form-label "
          title="Website Name"
          required
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="website_name"
            placeholder="Website Name"
            required
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="website_url"
          title="Website URL"
          required
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            id="website_url"
            type="text"
            name="website_url"
            placeholder="Website URL"
            required
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="tag_line"
          className="col-sm-3 col-form-label"
          title="Tag Line"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="tag_line"
            id="tag_line"
            placeholder="Tag Line"
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="short_name"
          title="Short Name (Optional)"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="short_name"
            id="short_name"
            placeholder="Short Name (Optional)"
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="address"
          title="Address"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="address"
            id="address"
            rows={3}
            placeholder="Address"
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="contact_numbers"
          title="Contact Numbers"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="mobile"
            id="mobile"
            rows={2}
            placeholder="Contact Numbers"
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="email"
          title="Email"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="email"
            id="email"
            rows={2}
            placeholder="Email"
          />
        </div>
      </div>
      {/* <div className="row mb-3">
        <InputLabel
          htmlFor="header_image"
          title="Header"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="header_image"
          // onChange={(e) => {
          //   previewHeaderImage(e);
          // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <label htmlFor="inputHeader" className="col-sm-3 col-form-label">
          Header Preview
        </label>
        <div className="col-sm-9">
          {isObject(values?.header_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.header_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.header_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div> */}
      {/* <div className="row mb-3">
        <InputLabel
          htmlFor="footer_image"
          title="Footer"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="footer_image"
          // onChange={(e) => {
          //   previewFooterImage(e);
          // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <label htmlFor="inputPhoneNo2" className="col-sm-3 col-form-label">
          Footer Preview
        </label>
        <div className="col-sm-9">
          {isObject(values?.footer_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.footer_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.footer_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div> */}
      {/* <div className="row mb-3">
        <InputLabel
          htmlFor="background_image"
          title="Report Background Image"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="background_image"
          // onChange={(e) => {
          //   previewBackgroundImage(e);
          // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <label htmlFor="inputPhoneNo2" className="col-sm-3 col-form-label">
          Background Preview
        </label>
        <div className="col-sm-9">
          {isObject(values?.background_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.background_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.background_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div> */}
      <div className="row mb-3">
        <InputLabel
          htmlFor="logo_image"
          title="Logo"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="logo_image"
          // onChange={(e) => {
          //   previewLogoImage(e);
          // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="inputPhoneNo2"
          title="Logo Preview"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          {isObject(values?.logo_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.logo_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.logo_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="fav_image"
          title="Favicon"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="file"
            name="fav_image"
          // onChange={(e) => {
          //   previewFaviconImage(e);
          // }}
          />
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="inputPhoneNo2"
          title="Favicon Preview"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          {isObject(values?.fav_image) ? (
            <img
              className="mt-3"
              src={URL.createObjectURL(values?.fav_image)}
              alt="preview"
              style={{ height: "100px" }}
            />
          ) : (
            <img
              className="mt-3"
              src={`${process.env.REACT_APP_UPLOAD_URL}/${values?.fav_image}`}
              alt="preview"
              style={{ height: "100px" }}
            />
          )}
        </div>
      </div>
      <div className="mb-3 row">
        <InputLabel
          htmlFor="vat_type"
          title="VAT Type"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <select
            value={values?.vat_type}
            onChange={(e) => setFieldValue("vat_type", e.target.value)}
            className="single-select form-select"
          >
            <option value={1}>Included</option>
            <option value={2}>Excluded</option>
          </select>
        </div>
      </div>
      <div className="row mb-3">
        <InputLabel
          htmlFor="currency"
          title="Currency"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="currency"
            id="currency"
            placeholder="Currency"
          />
        </div>
      </div>
      {/* <div className='row mb-3'>
        <label className='col-sm-3 col-form-label'>Currency</label>
        <div className='col-sm-9'>
          <input
            type='text'
            className='form-control'
            onChange={handleChange}
            value={values?.currency}
            name='currency'
            id='inputEnterYourName'
            placeholder={values?.currency}
          />
        </div>
      </div> */}
      {/* <div className="mb-3 row">
        <InputLabel
          htmlFor="inputDaysOfWeek"
          className="col-sm-3 col-form-label d-flex justify-content-start"
          title="Days of Week"
        />
        <div className="col-sm-9">
          <ReactMultiSelect
            name="days_of_week"
            isMulti
            value={daysOfWeekData.filter((item) =>
              values?.days_of_week?.includes(item.id)
            )}
            onChange={(e) => {
              const daysOfWeekString = e.map((item) => item.id).join(",");
              setFieldValue("days_of_week", daysOfWeekString);
            }}
            options={daysOfWeekData}
            valueName="id"
            labelName="value"
          />
        </div>
      </div> */}
      {/* <div className="row mb-3">
        <InputLabel
          htmlFor="point"
          title="1 Point ="
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput type="number" name="point" placeholder="1 Point =" />
        </div>
      </div> */}
      {/* <div className="row mb-3">
        <InputLabel
          htmlFor="introducer_label"
          title="Introducer Label"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput
            type="text"
            name="introducer_label"
            placeholder="Introducer Label"
          />
        </div>
      </div> */}
      {/* <div className="row mb-3">
        <InputLabel
          htmlFor="reg_prefix"
          title="Reg. Prefix"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput type="text" name="reg_prefix" placeholder="Reg. Prefix" />
        </div>
      </div> */}
      {/* <div className="row mb-3">
        <InputLabel
          htmlFor="reg_no"
          title="Reg. No."
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-2">
          <select
            className="form-select medical-form-select py-2 fw-bold"
            name="reset_sequence_in_month"
            aria-label="Default select example"
            style={{ maxWidth: "160px" }}
            value={values?.reset_sequence_in_month}
            onChange={(e) =>
              setFieldValue("reset_sequence_in_month", e.target.value)
            }
          >
            <option value={""}>Reset Sequence In Monthly</option>
            <option value={1}>Yes</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-sm-2">
          <select
            className="form-select medical-form-select py-2 fw-bold"
            name="year"
            aria-label="Default select example"
            style={{ maxWidth: "160px" }}
            value={values?.year}
            onChange={(e) => setFieldValue("year", e.target.value)}
          >
            <option value={""}>Select Year</option>
            <option value={1}>Yes</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-sm-2">
          <select
            className="form-select medical-form-select py-2 fw-bold"
            name="month"
            aria-label="Default select example"
            style={{ maxWidth: "160px" }}
            value={values?.month}
            onChange={(e) => setFieldValue("month", e.target.value)}
          >
            <option value={""}>Select Month</option>
            <option value={1}>Yes</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-sm-2">
          <ReactInput
            style={{ maxWidth: "160px" }}
            type="text"
            name="starting_digit"
            placeholder="Starting Digit"
          />
        </div>
      </div> */}

      {/* <div className="row mb-3">
        <InputLabel
          htmlFor="package_in_medical_form"
          title="Package in Medical Form"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactSelect
            data={[
              { id: 1, value: "Show" },
              { id: 2, value: "Hide" },
            ]}
            value={values?.package_in_medical_form}
            onChange={(e) => setFieldValue("package_in_medical_form", e)}
            valueName="id"
            labelName="value"
            placeholder="Package in Medical Form"
          />
        </div>
      </div> */}

      <div className="row mb-3">
        <InputLabel
          htmlFor="copyright"
          title="Copyright"
          className="col-sm-3 col-form-label"
        />
        <div className="col-sm-9">
          <ReactInput type="text" name="copyright" placeholder="Copyright" />
        </div>
      </div>
      <div className="row">
        <label className="col-sm-3 col-form-label" />
        <div className="col-sm-9">
          {accessPerm(1, 2) && (
            <button type="submit" className="btn btn-primary px-5">
              Update
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingsForm;
